// @flow

import statusFormatter from './status.formatter';
import rstOff from './rstOff.formatter';
import rstAllo from './rstAllo.formatter';
import rstPrem from './rstPrem.formatter';
import rstApp from './rstApp.formatter';
import rsState from './rstState.formatter';
import rstMax from './rstMax.formatter';
import rstMo from './rstMo.formatter';
import rstBo from './rstBo.formatter';
import type { FormatterArgs } from '../../../types';

const formatters = (args: FormatterArgs): Array<any> =>
  [
    statusFormatter,
    rstOff,
    rstAllo,
    rstPrem,
    rstApp,
    rsState,
    rstMax,
    rstMo,
    rstBo,
  ].map(formatter => formatter(args));

export default formatters;
